import {
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  SET_SELECTED_COMPANY,
  SET_SELECTED_STORE,
  SET_COUNTRY_STORES,
  RESET_USER,
} from './action'
import { regionStorageKey } from '@common/src/config/regions'

const initialState = {
  user: null,
  permissions: [],
  companies: [],
  stores: [],
  selectedCompany: null,
  selectedStore: null,
  countryStores: [],
  // Start as true so PrivateRoute waits for Firebase auth to resolve
  // before making any redirect decisions.
  loading: true,
  error: null,
  menuItems: [],
}
export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_USER_DETAILS_SUCCESS:
      return {
        ...state,
        user: action.payload.userData,
        permissions: action.payload.permissions,
        companies: action.payload.companies,
        stores: action.payload.stores,
        menuItems: action.payload.menuItems,
        selectedStore: action.payload.stores[0],
        countryStores: action.payload.stores,
        loading: false,
        error: null,
      }

    case FETCH_USER_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case SET_SELECTED_COMPANY:
      localStorage.setItem(regionStorageKey('selectedCompany'), JSON.stringify(action.company))
      return {
        ...state,
        selectedCompany: action.company,
      }
    case SET_SELECTED_STORE:
      localStorage.setItem(regionStorageKey('selectedStore'), JSON.stringify(action.store))
      return {
        ...state,
        selectedStore: action.store,
      }
    case SET_COUNTRY_STORES:
      return {
        ...state,
        countryStores: action.storeData,
      }

    case RESET_USER:
      return {
        ...initialState,
        loading: false, // Auth resolved — user is not logged in
      }

    default:
      return state
  }
}
